import React from 'react';
import { Routes, Route, useLocation, Navigate } from 'react-router-dom';
import Layout from './components/Layout';
import Home from './pages/Home';
import Contact from './pages/Contact';
import WhoWeAre from './pages/WhoWeAre';
import SectorsL2MI from './pages/SectorsL2MI';
import PolitiqueQualiteAirMetrologie from './pages/PolitiqueQualiteAirMetrologie';
import PolitiqueQualiteL2MI from './pages/PolitiqueQualiteL2MI';
import SectorsAirMetrologie from './pages/SectorsAirMetrologie';
import Accreditations from './pages/Accreditations';
import FloatingContact from './components/FloatingContact';
import Reclamation from './pages/Reclamation';
import UnderConstruction from './pages/UnderConstruction';
import pageConfig from './config/pageConfig';
import Carrieres from './pages/Carrieres';
import DirectorMessage from './pages/DirectorMessage';

function ProtectedRoute({ children }) {
  const location = useLocation();
  const search = location.search; // Récupère les paramètres d'URL
  const fullPath = `${location.pathname}${search}`; // Combine le chemin et les paramètres

  // Vérifie si la page est en construction
  const isUnderConstruction = Object.entries(pageConfig.underConstruction).some(([path, isConstruction]) => {
    // Si le chemin dans la config correspond exactement au chemin complet actuel
    if (path === fullPath && isConstruction) {
      return true;
    }
    // Si le chemin dans la config correspond au pathname sans les paramètres
    if (path === location.pathname && isConstruction) {
      return true;
    }
    return false;
  });

  if (isUnderConstruction) {
    // Stocke le chemin complet pour pouvoir y revenir plus tard si nécessaire
    return <Navigate to="/under-construction" state={{ from: fullPath }} replace />;
  }

  return children;
}

function App() {
  return (
    <>
      <Routes>
        <Route path="/" element={<Layout />}>
          <Route index element={<Home />} />
          <Route path="/contact" element={
            <ProtectedRoute>
              <Contact />
            </ProtectedRoute>
          } />
          <Route path="/who-we-are" element={
            <ProtectedRoute>
              <WhoWeAre />
            </ProtectedRoute>
          } />
          <Route path="/mot-du-directeur" element={
            <ProtectedRoute>
              <DirectorMessage />
            </ProtectedRoute>
          } />
          <Route path="/secteurs-l2mi" element={
            <ProtectedRoute>
              <SectorsL2MI />
            </ProtectedRoute>
          } />
          <Route path="/secteurs-air-metrologie" element={
            <ProtectedRoute>
              <SectorsAirMetrologie />
            </ProtectedRoute>
          } />
          <Route path="/accreditations" element={
            <ProtectedRoute>
              <Accreditations />
            </ProtectedRoute>
          } />
          <Route path="/politique-qualite-l2mi" element={
            <ProtectedRoute>
              <PolitiqueQualiteL2MI />
            </ProtectedRoute>
          } />
          <Route path="/politique-qualite-airmetrologie" element={
            <ProtectedRoute>
              <PolitiqueQualiteAirMetrologie />
            </ProtectedRoute>
          } />
          <Route path="/reclamation" element={
            <ProtectedRoute>
              <Reclamation />
            </ProtectedRoute>
          } />
          <Route path="/carrieres" element={
            <ProtectedRoute>
              <Carrieres />
            </ProtectedRoute>
          } />
          <Route path="/under-construction" element={<UnderConstruction />} />
        </Route>
      </Routes>
      <FloatingContact />
    </>
  );
}

export default App;
